import Model from './Model'

export default class Log extends Model {
    /*
        URL Resource name
    */
    resource()
    {
        return 'logs'
    }
    /*
        Search by fields:
    */
    static searchForAll(name, params){
        return [];
    }
    /*
        Search by specific field:
    */
    static searchBy(field, value, params){
        return [];
    }

    static getNullObject(){
        return {
            rate: 0,
            name: '',
            symbol: ''
        }
    }
}